import React from "react";
import Reinitialiser from "../../../../../assets/Gestion-utilisateur-réinitialiser.png"

class BtnReinitialiser extends React.Component {
    constructor(props) {
      super(props);
      this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }
    btnClickedHandler() {
     this.props.clicked(this.props.value);
    }
    render() {
      return (
        <button className='ButtonGestionUtilisateur BGUGrey' onClick={this.btnClickedHandler}> <img src={Reinitialiser} className="IconHome" alt='icone' style={{marginLeft:'-10px'}}/> </button>
      )
    }
  }
export default BtnReinitialiser